export const optionalArg = (path: string, arg: string) => path.replace(`:${arg}`, `:${arg}?`);
